import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Breadcrumb, Form, Space, Spin } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Upload } from "antd";
import { Col, Row } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import InputField from "../../common/htmlComponents/InputField";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { DeleteOutlined } from "@ant-design/icons";
import { authUserData } from "../../utils/Helper";

const AddDocuments = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const DocumentsId = id ? atob(id) : null;
  const formRef = useRef();

  const initialState = {
    company: authUserData()?.company ? authUserData()?.company : null,
    document_name: null,
  };

  const [uploadFile, setUploadFile] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [size, setSize] = useState(null);
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [state, setState] = useState(initialState);

  useEffect(() => {
    const documentGetById = async () => {
      try {
        setapiLoading(true);
        const response = await getRequest(`company-document/${DocumentsId}/`);
        if (response.data.success) {
          setState(response.data.data);
          setFileLink(response.data.data.upload_document);
          formRef.current.setFieldsValue(response.data.data);
          setapiLoading(false);
        } else {
          ErrorNotificationMsg(t("error_in_company_documents_list"));
        }
      } catch (error) {
        setapiLoading(false);
      }
    };
    if (DocumentsId !== null) {
      documentGetById();
    }
  }, [DocumentsId, t]);

  const url = state.upload_document;

  let filename = "";
  try {
    if (fileLink) {
      filename = url.split("/").pop();
    }
  } catch (e) {
    filename = "";
  }

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async () => {
    setBtnLoading(true);

    const payload = {
      company: state.company,
      document_name: state.document_name,
    };

    try {
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("upload_document", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      if (DocumentsId === null) {
        apiResponse = await postRequest(
          "company-document/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `company-document/${DocumentsId}/`,
          formData,
          customerHeaders
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          DocumentsId === null
            ? t("company_documents_added_successfully")
            : t("company_documents_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        navigate("/company-documents");
      } else {
        ErrorNotificationMsg(t("error_in_add_company_documents"));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const uploadProps = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,

    beforeUpload: (file) => {
      setSize(file.size);
      if (file.size <= 2097152) {
        setUploadFile(file);
        setFileName(file.name);
      }
      return false;
    },
  };

  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      upload_document: null,
    }));
    setUploadFile("");
    setFileName(null);
    setSize(null);
  };

  const handleFileDelete = async () => {
    const apiResponse = await deleteRequest(
      `company-upload-document-delete/${DocumentsId}/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setFileLink(null);
      setFileName(null);
      setSize(null);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("pl_add_documents")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/company-documents">{t("pl_company_documents")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_add_documents")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Row gutter={[15]}>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="document_name"
                    className="BrowsButtonSec"
                    label={t("pl_document_name")}
                    placeholder={t("pl_enter_document_name")}
                    handleInputChange={handleInputChange}
                    prefix={<FileAlt />}
                    rules={t("val_document_name")}
                  />
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    className="BrowsButtonSec"
                    label={t("pl_upload_document")}
                    name="upload_document"
                    rules={[
                      {
                        required: false,
                        message: <Trans>{t("val_file")}</Trans>,
                      },
                    ]}
                  >
                    {size <= 2097152 && (
                      <>
                        <Space className="uploadedfile" size={[12, 16]}>
                          <a
                            href={fileLink}
                            className="link-color"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            {fileLink ? filename : fileName}
                          </a>
                          {fileLink && (
                            <DeleteOutlined onClick={handleFileDelete} />
                          )}
                          {fileName && (
                            <DeleteOutlined onClick={handleDelete} />
                          )}
                        </Space>
                      </>
                    )}
                    <Upload className="BrowsButton" {...uploadProps}>
                      <Button icon={<FileImageOutlined />}>
                        {t("pl_choose_document")}
                      </Button>
                    </Upload>
                    <div className="condition">
                      {" "}
                      <p
                        style={{
                          color: size > 2097152 ? "red" : "GrayText",
                        }}
                      >
                        {t("upload_fileSize")} {t("upload_imagefileType")}
                      </p>
                    </div>
                  </Form.Item>
                </Col>
              </Row>

              <div className="FormFooter">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={() => navigate("/company-documents")}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Submit"
                  label={t("save")}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};

export default AddDocuments;
